import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-trading data 394",
  "use": "icon-trading data 394-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-trading data 394\"><path d=\"M224 224V768H832v64H256a96 96 0 0 1-95.893333-91.477333L160 736v-512h64z m160 149.333333v325.333334h-64V373.333333h64z m298.666667 133.333334v192h-64v-192h64zM533.333333 245.333333v453.333334h-64V245.333333h64z\" p-id=\"25535\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol